<script setup lang="ts">
import Quill from "quill";
import { useWordProcessorStore } from "../useWordProcessorStore";

const props = defineProps({
  formattingAttribute: {
    // bold | underline | italic
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    required: false,
  },
});

const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { selectionRange, quillDelta, editorRef } =
  storeToRefs(wordProcessorStore);

const isActive = computed(() => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return "";

  const selection = selectionRange.value;
  if (!selection) return "";

  const format = quill.getFormat(selection.index, selection.length);

  return format[props.formattingAttribute] != undefined;
});

const onFormattingClicked = () => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;

  if (isActive.value) {
    quill.format(props.formattingAttribute, false, Quill.sources.USER);
  } else {
    quill.format(props.formattingAttribute, true, Quill.sources.USER);
  }
};
</script>

<template>
  <div
    class="w-[30px] h-[30px] rounded flex items-center justify-center relative cursor-pointer"
    :class="{
      'bg-primary/20 text-primary hover:bg-primary/10': isActive,
      'hover:bg-light': isActive != true,
    }"
    @click="onFormattingClicked"
    v-tooltip="tooltip"
  >
    <slot />
  </div>
</template>

<style scoped></style>
